function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 121 155",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M112.625,131.758l-52.208,21.4l-52.209,-21.4c-4.966,-2.037 -8.208,-6.854 -8.208,-12.204l0,-106.358c0,-7.288 5.933,-13.196 13.254,-13.196l94.325,0c7.321,0 13.254,5.908 13.254,13.196l0,106.358c0,5.35 -3.241,10.167 -8.208,12.204Z",
    style: {
      fill: "#b7b7b7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.07,92.76l-8.754,0.053c-0.003,-0.188 -1.639,-19.7 2.344,-30.832c2.326,-6.507 6.569,-10.649 12.671,-10.624c4.278,0.019 7.179,1.349 9.252,3.298c2.757,2.595 4.035,6.632 4.529,11.219c0.361,3.367 0.35,7.057 0.931,10.247c0.318,1.739 0.67,3.354 1.974,4.246c0.847,0.577 2.026,0.756 3.595,0.705c0.971,-0.031 1.74,-0.185 2.315,-0.577c0.908,-0.618 1.243,-1.697 1.535,-2.877c0.57,-2.3 0.653,-5.02 0.786,-7.734c0.497,-9.902 2.344,-19.004 13.94,-19.255c9.076,-0.197 13.848,6.307 15.643,15.164c2.072,10.234 0.341,24.554 0.341,27.02l-8.758,-0c0,-2.309 1.769,-15.766 -0.17,-25.342c-0.885,-4.367 -2.385,-8.339 -6.862,-8.242c-1.327,0.032 -2.33,0.258 -3.041,0.829c-1.248,1.01 -1.578,2.717 -1.867,4.561c-0.508,3.232 -0.462,6.925 -0.766,10.295c-0.491,5.468 -2.092,10.127 -5.786,12.647c-1.766,1.208 -4.035,2.014 -7.024,2.111c-4.107,0.132 -7.023,-0.881 -9.171,-2.447c-2.092,-1.528 -3.52,-3.649 -4.425,-6.203c-1.02,-2.886 -1.338,-6.416 -1.569,-9.974c-0.174,-2.695 -0.289,-5.403 -0.925,-7.683c-0.286,-1.023 -0.636,-1.955 -1.376,-2.583c-0.711,-0.602 -1.746,-0.815 -3.139,-0.822c-1.289,-0.006 -2.17,0.778 -2.89,1.826c-1.292,1.88 -2.07,4.496 -2.616,7.326c-1.939,10.021 -0.719,23.497 -0.717,23.648Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverProvider);
export default __webpack_public_path__ + "static/media/silver-provider.8c35d3059493b307a68145fa895d37e8.svg";
export { ForwardRef as ReactComponent };